import {DomainObject} from 'shared/DomainObject';
import { action, computed, observable, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';
import _ from 'lodash';
import {t} from 'shared/core';
import RoleAssignment from './RoleAssignment';

class User extends DomainObject {
  id;
  firstName;
  lastName;
  email;
  avatarColour;
  avatarInitials;
  active;
  provider;
  calendarAppConnected;
  meetingAppConnected;

  currentPassword;
  newPassword;
  confirmPassword;

  roleAssignments = [];
  mfaType;
  unsubscribedFromEmails;
  slackEnabled;
  partnerName;

  recruitingEmailNotification;
  payrollUpdateEmailNotification;
  benefitUpdateEmailNotification;
  birthdaySharedInternally;
  timeOffApprovedNotification;
  calendarAppConnectionType;
  meetingAppConnectionType;

  _relations = {
    roleAssignments: [RoleAssignment]
  };

  constructor(other) {
    super();
    makeObservable(this, {
      id: observable,
      firstName: observable,
      lastName: observable,
      email: observable,
      avatarColour: observable,
      avatarInitials: observable,
      active: observable,
      provider: observable,
      calendarAppConnected: observable,
      meetingAppConnected: observable,
      currentPassword: observable,
      newPassword: observable,
      confirmPassword: observable,
      roleAssignments: observable,
      mfaType: observable,
      unsubscribedFromEmails: observable,
      slackEnabled: observable,
      partnerName: observable,
      recruitingEmailNotification: observable,
      payrollUpdateEmailNotification: observable,
      benefitUpdateEmailNotification: observable,
      birthdaySharedInternally: observable,
      timeOffApprovedNotification: observable,
      calendarAppConnectionType: observable,
      meetingAppConnectionType: observable,
      resetPasswordFields: action,
      name: computed,
      roleNames: computed
    });
    this.merge(other);
  }

  resetPasswordFields() {
    this.currentPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  get name() {
    return fullName(this);
  }

  get roleNames() {
    const roleNames = _.map(this.roleAssignments, (assignment) => {
      return assignment.role.nameView;
    });

    if (this.manager) {
      roleNames.unshift(t('company_settings.permissions.default_roles.Manager'));
    }

    return roleNames;
  }

  static defaultOrderAttribute() {
    return 'name';
  }
}

export default User;
